import React, { useRef, useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import {
    getActivebannerlists,
    Addbanner,
    UpdateBanner,
    changeBannerStatus,
    DeleteBanner,
} from "../../../Services/Admin/Admin";
import Table from "../../../Extracomponents/Table";
import { SquarePen, Trash2 } from "lucide-react";
import { fDateTime } from "../../../../Utils/Date_formate";
import { image_baseurl } from "../../../../Utils/config";
import { Tooltip } from "antd";
import Loader from "../../../../Utils/Loader";
import ReusableModal from "../../../components/Models/ReusableModal";
import showCustomAlert from "../../../Extracomponents/CustomAlert/CustomAlert";




const ActiveBanner = () => {

    const today = new Date().toISOString().split("T")[0]

    const navigate = useNavigate();
    const [clients, setClients] = useState([]);
    const [model, setModel] = useState(false);
    const [serviceid, setServiceid] = useState({});
    const [searchInput, setSearchInput] = useState("");
    const fileInputRef = useRef(null);
    const [showModal, setShowModal] = useState(false);
    const [selectedOption, setSelectedOption] = useState("");
    const [isLoading, setIsLoading] = useState(true);

    const [updatetitle, setUpdatetitle] = useState({
        title: "",
        id: "",
        description: "",
        image: "",
        hyperlink: "",
        type: "",
        start: "",
        end: ""
    });



    const [title, setTitle] = useState({
        title: "",
        description: "",
        image: "",
        add_by: "",
        hyperlink: "",
        type: "",
    });

    const token = localStorage.getItem("token");
    const userid = localStorage.getItem("id");




    const getBanner = async () => {
        try {
            const response = await getActivebannerlists(token);
            if (response.status) {
                const filterdata = response.data.filter(
                    (item) =>
                        searchInput === "" ||
                        item.title.toLowerCase().includes(searchInput.toLowerCase())
                );
                setClients(searchInput ? filterdata : response.data);
            }
        } catch (error) {
            console.log("Error fetching services:", error);
        }
        setTimeout(() => {
            setIsLoading(false);
        });
    };




    useEffect(() => {
        getBanner();
    }, [searchInput]);




    useEffect(() => {
        if (updatetitle.hyperlink) {
            setSelectedOption("hyperlink");
        } else if (updatetitle.type) {
            setSelectedOption("type");
        } else {
            setSelectedOption("");
        }
    }, [updatetitle]);




    // Update banner
    const updatebanner = async () => {
        try {
            const data = {
                id: serviceid._id,
                image: updatetitle.image,
                hyperlink: updatetitle.hyperlink,
                type: updatetitle.type,
                start: updatetitle.start,
                end: updatetitle.end
            };

            const response = await UpdateBanner(data, token);

            if (response && response.status) {
                showCustomAlert("Success", response.message);
                setUpdatetitle({ title: "", id: "", hyperlink: "", image: "", type: "", start: "", end: "" });
                getBanner();
                setModel(false);
            } else {
                showCustomAlert("error", response.message);
            }
        } catch (error) {
            showCustomAlert("error", "server error");
        }
    };




    // Add banner
    const AddBanner = async () => {
        try {
            const data = {
                title: title.title,
                description: title.description,
                image: title.image,
                add_by: userid,
                hyperlink: title.hyperlink,
                type: title.type,
            };

            const response = await Addbanner(data, token);
            if (response && response.status) {
                showCustomAlert("Success", response.message);

                setTitle({ title: "", add_by: "", hyperlink: "", image: "", type: "" });
                fileInputRef.current.value = "";
                setShowModal(false);
                getBanner();

                const modal = document.getElementById("exampleModal");
                const bootstrapModal = window.bootstrap?.Modal.getInstance(modal);
                if (bootstrapModal) {
                    bootstrapModal.hide();
                }
            } else {
                showCustomAlert("error", response.message);
            }
        } catch (error) {
            showCustomAlert("error", "server error");
        }
    };



    // Status toggle
    const handleSwitchChange = async (event, id) => {
        const user_active_status = event.target.checked ? "true" : "false";
        const data = { id: id, status: user_active_status };
        const result = await showCustomAlert("confirm", "Do you want to save the changes?")
        if (result.isConfirmed) {
            try {
                const response = await changeBannerStatus(data, token);
                if (response.status) {
                    showCustomAlert("Success", "Status Changed")
                }
                getBanner();
            } catch (error) {
                showCustomAlert("error", "There was an error processing your request.")
            }
        } else {
            event.target.checked = !user_active_status
            getBanner();
        }
    };




    // Delete banner
    const Deletebannerlist = async (_id) => {
        try {
            const result = await showCustomAlert("confirm", "Do you want to delete this? This action cannot be undone.");
            if (result.isConfirmed) {
                const response = await DeleteBanner(_id, token);
                if (response.status) {
                    showCustomAlert("Success", "The Banner has been successfully deleted.");
                    getBanner();
                }
            } else {
                showCustomAlert("error", "The Banner deletion was cancelled.");
            }
        } catch (error) {
            showCustomAlert("error", "There was an error deleting the Banner.");
        }
    };



    const formatDate = (date) => date ? new Date(date).toISOString().split('T')[0] : '';



    const columns = [
        {
            name: "Image",
            cell: (row) => (
                <img
                    src={`${image_baseurl}uploads/banner/${row.image}`}
                    alt={row.image}
                    title={row.image}
                    width="50"
                    height="50"
                />
            ),
            sortable: true,
        },
        {
            name: "Active Status",
            selector: (row) => (
                <div className="form-check form-switch form-check-info">
                    <input
                        id={`rating_${row.status}`}
                        className="form-check-input toggleswitch"
                        type="checkbox"
                        checked={row.status == true}
                        onChange={(event) => handleSwitchChange(event, row._id)}
                    />
                    <label
                        htmlFor={`rating_${row.status}`}
                        className="checktoggle checkbox-bg"
                    ></label>
                </div>
            ),
            sortable: true,
        },
        {
            name: "Start Date",
            selector: (row) => fDateTime(row?.start) || "-",
            sortable: true,
        },
        {
            name: "End Date",
            selector: (row) => fDateTime(row?.end) || "-",
            sortable: true,
        },
        {
            name: "Actions",
            cell: (row) => (
                <>
                    <div>
                        <Tooltip placement="top" overlay="Update">
                            <SquarePen
                                onClick={() => {
                                    setModel(true);
                                    setServiceid(row);
                                    setUpdatetitle({
                                        title: row.title,
                                        id: row._id,
                                        description: row.description,
                                        image: row.image,
                                        hyperlink: row.hyperlink,
                                        type: row.type,
                                        start: formatDate(row.start),
                                        end: formatDate(row.end),
                                    });
                                }}
                            />
                        </Tooltip>
                    </div>
                    {/* <div>
                        <Tooltip placement="top" overlay="Delete">
                            <Trash2 onClick={() => Deletebannerlist(row._id)} />
                        </Tooltip>
                    </div> */}
                </>
            ),
            ignoreRowClick: true,
            allowOverflow: true,
            button: true,
        },
    ];

    const updateServiceTitle = (updatedField) => {
        setUpdatetitle((prev) => ({
            ...prev,
            ...updatedField,
        }));
    };

    return (
        <div>
            <div className="page-content">
                <div className="page-breadcrumb d-flex align-items-center justify-content-between mb-3">
                    <div>
                        <button className="btn btn-primary" onClick={() => window.history.back()}>
                            <i className="bx bx-arrow-back"></i> Back
                        </button>
                    </div>

                    <div className="d-flex align-items-center">
                        <div className="ps-3">
                            <nav aria-label="breadcrumb">
                                <ol className="breadcrumb mb-0 p-0">
                                    <li className="breadcrumb-item">
                                        <Link to="/admin/dashboard">
                                            <i className="bx bx-home-alt" />
                                        </Link>
                                    </li>
                                </ol>
                            </nav>
                        </div>
                        <div className="breadcrumb-title pe-3">Offer Banner</div>

                    </div>

                </div>

                <hr />

                <div className="card">
                    <div className="card-body">
                        <div className="d-lg-flex align-items-center justify-content-between mb-4 gap-3">
                            <ReusableModal
                                show={model}
                                onClose={() => setModel(false)}
                                title={<>Update Banner</>}
                                body={
                                    <>
                                        <div className="row">
                                            <div className="col-md-12">
                                                <label htmlFor="imageUpload">Image</label>
                                                <span className="text-danger">*</span>
                                                <input
                                                    className="form-control mb-3"
                                                    type="file"
                                                    accept="image/*"
                                                    id="imageUpload"
                                                    onChange={(e) => {
                                                        const file = e.target.files[0];
                                                        if (file) {
                                                            updateServiceTitle({ image: file });
                                                        }
                                                    }}
                                                />
                                            </div>
                                            <div className="col-md-2">
                                                {updatetitle.image && (
                                                    <div className="file-preview">
                                                        <img
                                                            src={
                                                                typeof updatetitle.image === "string"
                                                                    ? `${image_baseurl}uploads/banner/${updatetitle.image}`
                                                                    : URL.createObjectURL(updatetitle.image)
                                                            }
                                                            alt="Image Preview"
                                                            className="image-preview mt-4"
                                                            style={{
                                                                width: "68px",
                                                                height: "auto",
                                                            }}
                                                        />
                                                    </div>
                                                )}
                                            </div>
                                        </div>


                                        <div className="col-md-12">
                                            <label>Choose Option</label>
                                            <div className="form-check">
                                                <input
                                                    type="radio"
                                                    className="form-check-input"
                                                    id="radioHyperlink"
                                                    name="updateOption"
                                                    value="hyperlink"
                                                    checked={selectedOption === "hyperlink"}
                                                    onChange={() => setSelectedOption("hyperlink")}
                                                />
                                                <label className="form-check-label" htmlFor="radioHyperlink">
                                                    Add Hyperlink
                                                </label>
                                            </div>
                                            <div className="form-check">
                                                <input
                                                    type="radio"
                                                    className="form-check-input"
                                                    id="radioType"
                                                    name="updateOption"
                                                    value="type"
                                                    checked={selectedOption === "type"}
                                                    onChange={() => setSelectedOption("type")}
                                                />
                                                <label className="form-check-label" htmlFor="radioType">
                                                    Add Type
                                                </label>
                                            </div>
                                        </div>

                                        {selectedOption === "hyperlink" && (
                                            <div className="col-md-12 mt-2">
                                                <label htmlFor="hyperlink">HyperLink</label>
                                                <input
                                                    className="form-control mb-2"
                                                    type="text"
                                                    placeholder="Enter Hyperlink"
                                                    value={updatetitle.hyperlink || ""}
                                                    onChange={(e) =>
                                                        updateServiceTitle({
                                                            ...updatetitle,
                                                            hyperlink: e.target.value,
                                                            type: "",
                                                        })
                                                    }
                                                />
                                            </div>
                                        )}


                                        {selectedOption === "type" && (
                                            <div className="col-md-12 mt-2">
                                                <label htmlFor="type">Type</label>
                                                <select
                                                    className="form-control mb-2"
                                                    id="type"
                                                    value={updatetitle.type || ""}
                                                    onChange={(e) =>
                                                        updateServiceTitle({
                                                            ...updatetitle,
                                                            type: e.target.value,
                                                            hyperlink: "",
                                                        })
                                                    }
                                                >
                                                    <option value="">Select Type</option>
                                                    <option value="1">Service</option>
                                                    <option value="2">Trades</option>
                                                    <option value="3">Basket</option>
                                                    <option value="4">Coupon</option>
                                                </select>
                                            </div>
                                        )}
                                        <div className="row">
                                            <div className="col-md-6">
                                                <label htmlFor="imageUpload">Start Date</label>
                                                <span className="text-danger">*</span>
                                                <input type="date"
                                                    className="form-control mb-3"
                                                    min={today}
                                                    value={updatetitle.start || ""}
                                                    onChange={(e) =>
                                                        updateServiceTitle({
                                                            ...updatetitle,
                                                            start: e.target.value,
                                                            type: "",
                                                        })
                                                    }
                                                />
                                            </div>
                                            <div className="col-md-6">
                                                <label htmlFor="imageUpload">End Date</label>
                                                <span className="text-danger">*</span>
                                                <input type="date"
                                                    className="form-control mb-3"
                                                    value={updatetitle.end || ""}
                                                    onChange={(e) =>
                                                        updateServiceTitle({
                                                            ...updatetitle,
                                                            end: e.target.value,
                                                            type: "",
                                                        })
                                                    }
                                                />
                                            </div>
                                        </div>

                                    </>
                                }
                                footer={
                                    <>
                                        <button
                                            type="button"
                                            className="btn btn-primary"
                                            onClick={updatebanner}
                                        >
                                            Save
                                        </button>
                                        <button
                                            className="btn btn-primary rounded-1"
                                            onClick={() => setModel(false)}
                                        >
                                            Cancel
                                        </button>
                                    </>
                                }
                            />

                        </div>

                        {isLoading ? (
                            <Loader />
                        ) : (
                            <>
                                <div className="table-responsive">
                                    <Table
                                        columns={columns}
                                        data={clients}
                                        pagination
                                        striped
                                        highlightOnHover
                                        dense
                                    />
                                </div>
                            </>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ActiveBanner;